import { render } from "./KeyFeatures.vue?vue&type=template&id=7349afbc&ts=true"
import script from "./KeyFeatures.vue?vue&type=script&lang=ts"
export * from "./KeyFeatures.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__